import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetRestaurants, actionDeleteRestaurant, actionStatisticsByRestaurant, actionSelectRestaurant, actionQRLink } from "../actions/RestaurantActions"
import { LOGIN_ROUTE, 
         RESTAURANTS_ADD_ROUTE, 
         RESTAURANTS_EDIT_ROUTE, 
         RESTAURANTS_COPY_ROUTE, 
         RESTAURANTS_STATISTICS_ROUTE,
         MENU_CATEGORY_ROUTE,
         TICKETS_ROUTE,
         TICKET_TYPES_ROUTE,
         RESERVATIONS_ROUTE } from "../config/RoutesConstants"
import Setting from "../provider/base/Settings"
import { 
  Container, 
  IconButton,
  Icon,
  Button,
  Box, 
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  Input,
  InputLabel,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tabs,
  Tab,
  Tooltip
} from "@material-ui/core"
import QRCode from "react-qr-code"
import ReactToPrint from "react-to-print";
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import TicketIcon from '@material-ui/icons/RestaurantMenu';
import OrdersIcon from '@material-ui/icons/FormatListNumbered';
import BookingsIcon from '@material-ui/icons/EventSeat';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CopyIcon from '@material-ui/icons/FileCopy'
import StatisticsIcon from '@material-ui/icons/BarChart'
import QRIcon from '@material-ui/icons/FilterCenterFocus';
import OpenMenuIcon from '@material-ui/icons/Link';
import CategoriesIcon from '@material-ui/icons/Category'
import Util, { ERROR, INFO } from '../common/Util'
import Roles from "../config/RolesConstants"
import Logo from "../common/assets/logo.png"


class Restaurants extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:25, count:0, restaurants:[], filter:"", 
                restaurantForDelete:false, restaurantQR:false, qrTablesPrint:[],
                qrTab:0, qrTableFrom:1, qrTableTo:1, qrLinkTable:"1", qrLoading:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteRestaurantSuccess=this.getDeleteRestaurantSuccess.bind(this)
    this.onConfirmDeleteRestaurant=this.onConfirmDeleteRestaurant.bind(this)
    this.onAddRestaurant=this.onAddRestaurant.bind(this)
    this.onCopyRestaurant=this.onCopyRestaurant.bind(this)
    this.onStatisticRestaurant=this.onStatisticRestaurant.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onChangeQRTab=this.onChangeQRTab.bind(this)
    this.onChangeTableFrom=this.onChangeTableFrom.bind(this)
    this.onChangeTableTo=this.onChangeTableTo.bind(this)
    this.onBeforeGetContent=this.onBeforeGetContent.bind(this)
    this.qrsMenu=new Array(12).fill("*")
  }

  componentWillMount(){
    if (this.props.login) {
      this.props.actionGetRestaurants(this.onChangePage, this.getRestaurantsError)
      let isSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})>=0)
      let isAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.ADMIN})>=0)
      let isOperador = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.OPERADOR})>=0)
      this.setState({isSuperAdmin:isSuperAdmin, isAdmin:isAdmin, isOperador:isOperador})
    }
  }

  getRestaurantsError(e){
    console.log("ERROR RESTURANTS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los restaurants.")
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let restaurants = this.props.restaurantList&&this.props.restaurantList.filter((e)=>{return e.evtName.match(filter)})||[]
    let count = restaurants.length
    restaurants = restaurants.slice(from, end)
    this.setState({page:newPage, count:count, restaurants:restaurants})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let restaurants = this.props.restaurantList&&this.props.restaurantList.filter((e)=>{return e.evtName.match(filter)})||[]
    let count = restaurants.length
    restaurants = restaurants.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, restaurants:restaurants})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }

  onStatisticRestaurant(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(RESTAURANTS_STATISTICS_ROUTE)
    // this.props.actionStatisticsByRestaurant(restaurant,
    //   ()=>this.props.history.push(RESTAURANTS_STATISTICS_ROUTE),
    //   this.getStatisticRestaurantError
    //   )
  }

  getStatisticRestaurantError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al consultar las estadísticas del restaurant.")
  }

  onGenerateQR(restaurant){
    this.setState({restaurantQR:restaurant, qrTablesPrint:[],
      qrTab:0, qrTableFrom:1, qrTableTo:1, qrLinkTable:"1"})
  }

  onCategories(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(MENU_CATEGORY_ROUTE)
  }

  onCopyRestaurant(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(RESTAURANTS_COPY_ROUTE)
  }

  onAddRestaurant(){
    this.props.history.push(RESTAURANTS_ADD_ROUTE)
  }
  
  onTicketTypes(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(TICKET_TYPES_ROUTE)
  }
  
  onTickets(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(TICKETS_ROUTE)
  }

  onBooking(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(RESERVATIONS_ROUTE)
  }

  onEditRestaurant(restaurant){
    this.props.actionSelectRestaurant(restaurant)
    this.props.history.push(RESTAURANTS_EDIT_ROUTE)
  }

  onConfirmDeleteRestaurant(){
    this.props.actionDeleteRestaurant(this.state.restaurantForDelete,this.getDeleteRestaurantSuccess,this.getDeleteRestaurantError)
    this.setState({restaurantForDelete:false})
  }
  
  onDeleteRestaurant(restaurant){
    this.setState({restaurantForDelete:restaurant})  
  }

  getDeleteRestaurantSuccess(){
    this.props.actionGetRestaurants(()=>{this.onChangePage(null,this.state.page)}, this.getRestaurantsError)
  }

  getDeleteRestaurantError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el comercio.")
  }

  onChangeQRTab(evt, newValue){
    this.setState({qrTab:newValue})
    newValue==1&&this.onChangeTableFrom({target:{value:1}})
    if(newValue==1&&this.state.restaurantQR&&!this.state.restaurantQR.resTable){
      Util.showNoty(INFO,"Recuerde habilitar el pedido en mesa")
    }
  }

  onChangeTableFrom(evt){
    let from = evt.target.value
    this.setState({qrTableFrom:from, qrLoading:true})
    this.props.actionQRLink(this.state.restaurantQR, from, 0,
      (r)=>{
        this.setState({qrLinkTable:r.shortLink, qrLoading:false})
      },
      (e)=>{
        console.log("ERROR QR LINK", e)
      }
    )
    // let to = this.state.qrTableTo
    // if(from <= to){
    //   let validValue = /\d/.test(evt.target.value)
    //   if(validValue){
    //     t
    //   }
    // }
    
    
    // this.props.actionQRLink(this.state.restaurantQR, evt.target.value,
    //   (r)=>{
    //     this.setState({qrLinkTable:r.shortLink, qrLoading:false})
    //   },
    //   (e)=>{
    //     console.log("ERROR QR LINK", e)
    //   }
    // )
    
    // this.setState({qrTablesPrint:tables})
  }

  onChangeTableTo(evt){
    this.setState({qrTableTo:evt.target.value})
  }

  onBeforeGetContent(){
    const {qrTab, restaurantQR, qrTableFrom, qrTableTo} = this.state
    if(qrTab==1){
      return new Promise((resolve, reject)=>{
        if(qrTableFrom>qrTableTo){
          Util.showNoty(ERROR, "La mesa desde no debe ser mayor a la mesa hasta")
          reject()
        }else{
          this.props.actionQRLink(restaurantQR, qrTableFrom, qrTableTo,
            (r)=>{
              this.setState({qrTablesPrint:r, qrLoading:false})
              resolve()
            },
            (e)=>{
              console.log("ERROR QR LINK", e)
              reject()
            }
          )
        }
      })
    }
  }
  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Nombre del local","Dirección"]
    if(this.state.isSuperAdmin){
      headers.push("Creado por")
      headers.push("Modificado por")
    }
    
    //Creado por y Modificado por tiene que ser condicionado por rol. Solo para SuperAdmin
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let restaurants = this.state.restaurants
    if(!restaurants||restaurants.length==0){
      if(this.state.isSuperAdmin){
        return <Box style={theme.table.empty}>No se encontraron registros</Box>
      }else{
        return <Box style={theme.table.empty}>Solicite al administrador que le asigne un comercio</Box>
      }
    }
    return restaurants.map((item, index)=>{
      // console.log(index, item)
      let isActive=item.evtState.toLowerCase() == "active"
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.evtName}</TableCell>
          <TableCell>{item.evtPlaceAddress}</TableCell>
          {this.state.isSuperAdmin?[
          <TableCell>{item.evtCreateUser}</TableCell>,
          <TableCell>{item.evtLastUpdateUser}</TableCell>
          ]:null}
          <TableCell style={{...theme.table.actionsColumn, minWidth:this.state.isSuperAdmin?292:260}}>
            {this.state.isOperador||this.state.isSuperAdmin?
            [<Tooltip title="Gestionar pedidos">
              <IconButton onClick={this.onTickets.bind(this, item)}>
                {/* <Icon className="fa fa-film"/> */}
                <OrdersIcon/>
              </IconButton>
            </Tooltip>,
            <Tooltip title="Gestionar reservas">
              <IconButton onClick={this.onBooking.bind(this, item)}>
                <BookingsIcon/>
              </IconButton>
            </Tooltip>
            ]
            :null}
            <Tooltip title="Gestionar items de menú">
              <IconButton onClick={this.onTicketTypes.bind(this, item)}>
                <TicketIcon/>
              </IconButton>
            </Tooltip>
            {this.state.isAdmin?
            <Tooltip title="Gestionar categorías de menú">
              <IconButton onClick={this.onCategories.bind(this, item)}>
                <CategoriesIcon/>
              </IconButton>
            </Tooltip>:null}
            <Tooltip title="Generar código QR">
              <IconButton onClick={this.onGenerateQR.bind(this, item)}>
                <QRIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Abrir menú">
              <IconButton href={`${Setting.MENU_URL_DOMAIN}?idCommerce=${item.id}`} target="_blank">
                <OpenMenuIcon/>
              </IconButton>
            </Tooltip>
            {this.state.isSuperAdmin || this.state.isAdmin?[
            <Tooltip title="Estadísticas del restaurant">
              <IconButton onClick={this.onStatisticRestaurant.bind(this, item)}>
                <StatisticsIcon/>
              </IconButton>
            </Tooltip>,
            <Tooltip title="Editar restaurant">
              <IconButton onClick={this.onEditRestaurant.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            ]:null}
            {this.state.isSuperAdmin?[
               <Tooltip title="Copiar restaurant">
               <IconButton onClick={this.onCopyRestaurant.bind(this, item)}>
                 <CopyIcon/>
               </IconButton>
             </Tooltip>,
            <Tooltip title="Eliminar restaurant">
              <IconButton onClick={this.onDeleteRestaurant.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>]
            :null}
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, restaurantList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Comercios</Typography>
          <Typography variant="subtitle1">Crea comercios</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de comercios</Typography>
            {this.state.isSuperAdmin?
            <Toolbar style={theme.table.toolbar}>

              <Tooltip title="Crear nuevo comercio">
                <Fab color="primary" onClick={this.onAddRestaurant} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
            :null}
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.restaurantForDelete}>
            <DialogTitle>Eliminar Comercio</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el comercio?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={()=>{this.setState({restaurantForDelete:null})}}>Cancelar</Button>
              <Button variant="contained" color="primary" onClick={this.onConfirmDeleteRestaurant}>Eliminar</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.state.restaurantQR} >
            <DialogTitle>
            <Tabs value={this.state.qrTab} onChange={this.onChangeQRTab} indicatorColor="primary" textColor="primary">
              <Tab label={`Menú de ${this.state.restaurantQR.evtName}`} />
              <Tab label={`Mesa de ${this.state.restaurantQR.evtName}`} />
            </Tabs>
              </DialogTitle>
            <DialogContent>
              {this.state.qrTab == 0?[
                <Box style={{width:250, padding:40, borderStyle:"dashed", borderWidth:1}}>
                  <QRCode value={`${Setting.MENU_URL_DOMAIN}?idCommerce=${this.state.restaurantQR.id}`} size={170}/>
                </Box>,
                <Box style={{display:"none"}}>
                  <Grid ref={(r)=>(this.qrRef = r)} container xs={12} direction="row">
                    <Grid container item xs={12} style={{margin:0, padding:31}} direction="row" alignItems="space-between" justify="space-between">
                      <img src={Logo} height={50}/>
                      <img src={this.state.restaurantQR&&this.state.restaurantQR.resLogo} height={50}/>
                    </Grid>
                    {this.qrsMenu.map(()=>{
                      return (
                      <Grid container item xs={4} style={{width:250, padding:40, borderStyle:"dashed", borderWidth:1, margin:0}}>
                        <QRCode value={`${Setting.MENU_URL_DOMAIN}?idCommerce=${this.state.restaurantQR.id}`} size={170}/>
                      </Grid>
                      )
                    })}
                  </Grid>
                </Box>
              ]
              :[
              <Box display="flex">
                <Box>
                  <InputLabel shrink={true}>Número de Mesa desde</InputLabel>
                  <Input value={this.state.qrTableFrom} type="number" style={{marginBottom:10}} onChange={this.onChangeTableFrom}/>
                </Box>
                <Box>
                  <InputLabel shrink={true}>Número de Mesa hasta</InputLabel>
                  <Input value={this.state.qrTableTo} type="number" style={{marginBottom:10}} onChange={this.onChangeTableTo}/>
                </Box>
              </Box>,
                this.state.qrLoading?
                  <Box display="flex">
                    {this.state.qrTableFrom?
                      [<CircularProgress color="primary" size={20}/>, <Typography style={{marginLeft:10}}>Cargando código QR</Typography>]
                    :<Typography>Ingrese un número de mesa</Typography>
                    }
                  </Box>
                :
                [
                  <Box style={{position:"relative", width:250, padding:40, borderStyle:"dashed", borderWidth:1, justifyContent:"center", alignItems:"center"}}>                  
                    <QRCode value={this.state.qrLinkTable} size={170}/>
                    <Box style={{position:"absolute", top:108, left:(109-this.state.qrTableFrom.toString().length) ,backgroundColor:"#C95933", paddingLeft:10, paddingRight:10, borderRadius:100, paddingTop:4, paddingBottom:4}}>
                      <Typography style={{fontSize:14, color:"white"}}>{this.state.qrTableFrom}</Typography>               
                    </Box>
                  </Box>,
                  <Box style={{display:"none"}}>
                    <Grid ref={(r)=>(this.qrRef = r)}  container xs={12} direction="row">
                      {this.state.qrTablesPrint.map((links, idx)=>{ 
                        let tableNumber = (parseInt(this.state.qrTableFrom)+idx)
                        return (
                          [
                          idx%6==0&&<Grid container item xs={12} style={{margin:0, padding:31}} direction="row" alignItems="space-between" justify="space-between">
                              <img src={Logo} height={50}/>
                              <img src={this.state.restaurantQR&&this.state.restaurantQR.resLogo} height={50}/>
                            </Grid>,
                          // idx%6==0&&<Grid container item xs={6} alignItems="flex-end" style={{marginTop:30, marginBottom:30, alignItems:"right", justifyContent:"right", textAlign:"right"}}>
                          //   <img src={this.state.restaurantQR&&this.state.restaurantQR.resLogo} height={50}/>
                          // </Grid>,
                          <Grid container item xs={4} style={{position:"relative", width:250, padding:40, borderStyle:"dashed", borderWidth:1, justifyContent:"center", alignItems:"center", margin:0}}>                  
                            <QRCode value={links.shortLink} size={170}/>
                            <Box style={{position:"absolute", top:108, left:(109-tableNumber.toString().length) ,backgroundColor:"#C95933", paddingLeft:10, paddingRight:10, borderRadius:100, paddingTop:4, paddingBottom:4}}>
                              <Typography style={{fontSize:14, color:"white"}}>{tableNumber}</Typography>               
                            </Box>
                          </Grid>,
                          <Grid container item xs={4} style={{position:"relative", width:250, padding:40, borderStyle:"dashed", borderWidth:1, justifyContent:"center", alignItems:"center", margin:0}}>                  
                            <QRCode value={links.shortLink} size={170}/>
                            <Box style={{position:"absolute", top:108, left:(109-tableNumber.toString().length) ,backgroundColor:"#C95933", paddingLeft:10, paddingRight:10, borderRadius:100, paddingTop:4, paddingBottom:4}}>
                              <Typography style={{fontSize:14, color:"white"}}>{tableNumber}</Typography>               
                            </Box>
                          </Grid>
                          ]
                        )
                      })}
                     </Grid>
                  </Box>
                ]
              ]
              }
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={()=>this.setState({restaurantQR:false})}>Cerrar</Button>
                <ReactToPrint 
                  trigger={()=>{ return (
                      <Button href="#" variant="contained" color="primary" diabled={this.state.qrLoading||this.state.qrTableFrom>this.state.qrTableTo}>Imprimir</Button> 
                      )}
                  }
                  onBeforeGetContent={this.onBeforeGetContent}
                  content={()=>this.qrRef}
                />
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    restaurantList: store.evt.restaurantList,
    profile: store.auth.profile,
		loading: store.app.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetRestaurants,
      actionDeleteRestaurant,
      actionStatisticsByRestaurant,
      actionSelectRestaurant,
      actionQRLink
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Restaurants)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Restaurants.js